import React, { useState,  useEffect } from 'react';
import { NavLink, useParams} from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import moment from 'moment';
import { Tooltip } from 'react-tooltip';
import apiService from './../../Auth/apiService.jsx';
import CustomInput from '../Utils/CustomInput2.jsx';
import DatosCabezaFamilia from '../Caracterizacion/DatosCabezaFamilia.jsx';
import { useAuth } from './../../Auth/AuthContext.jsx';
import SweetAlert2 from 'react-sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import { DatePicker, registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import MenuReincorporados from './MenuReincorporados.jsx';
import confirmarConToast from "../Utils/confirmarConToast.jsx";
registerLocale('es', es);
setDefaultLocale('es');

export default function HechosVictimizantesrei(){
    const { token, user, rol } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [swalProps, setSwalProps] = useState({});
    const [municipios, setMunicipios] = useState([]);
    const [tiposLugar, setTiposLugar] = useState([]);
    const [hechosVictimizantes, setHechosVictimizantes] = useState([]);
    const [hechosVictimizantesPersona, setHechosVictimizantesPersona] = useState([]);
    const { control, handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [cabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
    });
    useEffect(() => {
        async function fetchData(){
            let url = '/reincorporados/crearformulariohechosvictimizantespersona';
            let obj = {idCabezaFamilia: idCabezaFamilia, userId: user }
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia || {});
                setMunicipios(result.municipios || []);
                setTiposLugar(result.tiposlugar || []);
                setHechosVictimizantes(result.hechosvictimizantes || []);
                ResetForm();
                setValue('int_creadopor', user);
                setValue('str_idcabezafamilia', idCabezaFamilia);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        }
        if(idCabezaFamilia){
            ListarHechosVictimizantes(idCabezaFamilia);
            fetchData();
        }
    }, [idCabezaFamilia]);
    
    async function ListarHechosVictimizantes (idPersona){
        try {
            let url = '/reincorporados/listarhechosvictimizantespersona/' + idPersona;
            const response = await apiService.get(url, token);
            const result = await response.data;
            setHechosVictimizantesPersona(result || []);
        } catch (error) {
            console.error('Error listing hechos victimizantes:', error);
        }
    }
    
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        try {
            if(data.id){
                url = '/reincorporados/actualizarhechosvictimizantespersona';
                const response = await apiService.put(url, data, token);
                if(response.status === 200){
                    Mensaje('Actualizar hechos victimizantes', JSON.stringify(response.data));
                    await ListarHechosVictimizantes(idCabezaFamilia);
                    ResetForm();
                }
            } else {
                url = '/reincorporados/guardarhechosvictimizantespersona';
                const response = await apiService.post(url, data, token);
                if(response.status === 200){
                    Mensaje('Registrar hechos victimizantes', JSON.stringify(response.data));
                    await ListarHechosVictimizantes(idCabezaFamilia);
                    ResetForm();
                }
            }
            
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar hechos victimizantes', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar hechos victimizantes', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            ResetForm();
        }
    };

    async function handleDelete(id) {
        const confirmDelete = await confirmarConToast({
            message: '¿Está seguro de que desea eliminar este hecho victimizante? Esto puede eliminar todas las atenciones relacionadas según el módulo al que pertenezca.',
            confirmText: 'Sí, eliminar',
            cancelText: 'Cancelar',
            type: 'warn',
        });
        if (!confirmDelete) {
            return;
        }
        try {
            setCargando(true);
            let url = '/reincorporados/eliminarhechosvictimizantespersona/' + id;
            const response = await apiService.borrar(url, token);
            if(response.status === 200){
                Mensaje('Eliminar hecho victimizante', 'El hecho victimizante ha sido eliminado correctamente.');
                await ListarHechosVictimizantes(idCabezaFamilia);
            }
        } catch (error) {
            console.error('Error deleting hecho victimizante:', error);
        } finally {
            setCargando(false);
        }
    }
    
    async function handleEdit(row) {
        setValue('id', row.id);
        setValue('str_idcabezafamilia', row.str_idcabezafamilia);
        setValue('int_municipio', row.int_municipio);
        setValue('int_departamento', row.int_departamento);
        setValue('str_lugar', row.str_lugar);
        setValue('int_tipolugar', row.int_tipolugar);
        setValue('dat_fechahecho', row.dat_fechahecho ? moment(row.dat_fechahecho).toDate() : moment().toDate());
        setValue('int_creadopor', user);
        setValue('int_hechovictimizanteid', row.int_hechovictimizanteid);
    }

    const ResetForm = () => {
        const fechahoy = new Date()
        setValue('id', '');
        setValue('str_idcabezafamilia', idCabezaFamilia);
        setValue('int_municipio', '');
        setValue('int_departamento', '');
        setValue('str_lugar', '');
        setValue('int_tipolugar', '');
        setValue('dat_fechahecho', fechahoy);
        setValue('int_creadopor', user);
        setValue('int_hechovictimizanteid', '');
    }
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Registrar hechos victimizantes</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Registrar hechos victimizantes</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuReincorporados idCabezaFamilia={idCabezaFamilia} />
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card card-info">
                            <div className="card-header">
                                <h3 className="card-title">Hechos Victimizantes de la Persona</h3>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Acciones</th>
                                                <th>ID</th>
                                                <th>Hecho Victimizante</th>
                                                <th>Fecha</th>
                                                <th>Municipio</th>
                                                <th>Departamento</th>
                                                <th>Lugar</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {hechosVictimizantesPersona.map(hecho => (
                                                <tr key={hecho.id}>
                                                    <td>
                                                        {rol === '2' && (
                                                            <button 
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => handleDelete(hecho.id)}
                                                                >Eliminar</button>
                                                        )}
                                                        <button 
                                                            className="btn btn-primary btn-sm"
                                                            onClick={() => handleEdit(hecho)}>Editar</button>
                                                    </td>
                                                    <td>{hecho.id}</td>
                                                    <td>{hechosVictimizantes.find(hv => hv.id === hecho.int_hechovictimizanteid)?.strNombre ?? ''}</td>
                                                    <td>{hecho.dat_fechahecho ?? ''}</td>
                                                    <td>{municipios.find(municipio => municipio.id === hecho.int_municipio)?.munMunicipio ?? ''}</td>
                                                    <td>{municipios.find(municipio => municipio.id === hecho.int_municipio)?.munDepartamento ?? ''}</td>
                                                    <td>{hecho.str_lugar}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="card card-info">
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                            <DatosCabezaFamilia datos={cabezaFamiliaDatos}></DatosCabezaFamilia>
                            <input hidden {...register('id')}/>
                            <input hidden {...register('int_creadopor')}/>
                            <input hidden {...register('str_idcabezafamilia')}/>
                            <input hidden {...register('int_departamento')}/>
                            <div className="row">
                                <div className='col-md-3'>
                                    <label htmlFor="int_hechovictimizanteid">Hecho Victimizante</label>
                                    <select 
                                        className="form-control" 
                                        id="int_hechovictimizanteid" {...register('int_hechovictimizanteid', { required: 'El hecho victimizante es obligatorio' })}>
                                        <option value="">Seleccione un hecho victimizante</option>
                                        {hechosVictimizantes.map(hecho => (
                                            <option key={hecho.id} value={hecho.id}>{hecho.strNombre}</option>
                                        ))}
                                    </select>
                                    {errors.int_hechovictimizanteid && <span className="text-danger">{errors.int_hechovictimizanteid.message}</span>}
                                </div>
                                <div className='col-md-3'>
                                    <label htmlFor="int_municipio">Municipio</label>
                                    <select 
                                        className="form-control" 
                                        id="int_municipio" {...register('int_municipio', { required: 'El municipio es obligatorio',
                                            onChange: (e) => {
                                                setValue('int_municipio', e.target.value);
                                                setValue('int_departamento', (municipios.find(m => m.id === e.target.value))?.munDepartamentoid || '');
                                            }
                                         })}>
                                        <option value="">Seleccione un municipio</option>
                                        {municipios.map(municipio => (
                                            <option key={municipio.id} value={municipio.id}>{municipio.munMunicipio} - {municipio.munDepartamento}</option>
                                        ))}
                                    </select>
                                    {errors.int_municipio && <span className="text-danger">{errors.int_municipio.message}</span>}
                                </div>
                                <div className='col-md-3'>
                                    <label htmlFor="int_tipolugar">Tipo de lugar</label>
                                    <select 
                                        type="text" 
                                        className="form-control" 
                                        id="int_tipolugar" 
                                        {...register('int_tipolugar')}>
                                        <option value="">Seleccione un tipo de lugar</option>
                                        {tiposLugar.map(tipo => (
                                            <option key={tipo.id} value={tipo.id}>{tipo.tipTipolugar}</option>
                                        ))}
                                    </select>
                                    {errors.int_tipolugar && <span className="text-danger">{errors.int_tipolugar.message}</span>}
                                </div>
                                <div className='col-md-3'>
                                    <label htmlFor="str_lugar">Lugar</label>
                                    <input type="text" className="form-control" id="str_lugar" {...register('str_lugar')} />
                                    {errors.str_lugar && <span className="text-danger">{errors.str_lugar.message}</span>}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="dat_fechahecho">Fecha del hecho</label>
                                        <Controller
                                            control={control}
                                            name="dat_fechahecho"
                                            render={({ field }) => (
                                                <DatePicker
                                                placeholderText="fecha"
                                                onChange={(date) => field.onChange(date)}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                selected={field.value}
                                                customInput={<CustomInput />}
                                                locale="es"
                                                dateFormat="yyyy-MM-dd"
                                                maxDate={new Date()}
                                                />
                                            )}
                                        />
                                        {errors.dat_fechahecho && <p style={{color: 'red'}}>Digite fecha del hecho</p>}
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-primary">Guardar</button>
                            </div>
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}